module.exports = new __parcel__URL__("services_3.42bc862f.png").toString();